var React = require('react');

function IcSend48px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.02 42L46 24 4.02 6 4 20l30 4-30 4z"}));
}

IcSend48px.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = IcSend48px;

IcSend48px.default = IcSend48px;
